
export const IDLE= 'idle'
export const SUCCESS= 'success'
export const ERROR= 'error'
export const LOADING= 'loading'

//asset protocl
export const SFTP = "sftp";
export const RDP = "rdp";
export const SSH = "ssh";
export const WEB_APP = "Web App";
export const SMB = "smb";

// special symbols
export const SPECIAL_SYMBOLS = "\\-!#$%&()*,./:;?@[]^_`{|}~+<=>";

